/**
 *
 * UpdateUsername Component
 *
 */

import React from "react";
import classnames from "classnames";
import { stylize, TextField } from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";
import messages from "./messages";
import styles, { Styles } from "./styles";
import { UpdateUsernameFlow } from "./types";

interface InjectedProps extends Styles {
  /** Internal - injected from withIntl */
  formatMessage: FormatMessage;

  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below
}

export interface UpdateUsernameProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;

  username: string;
  flow: UpdateUsernameFlow;
  onUsernameChange: (username: string) => void;
  onUsernameBlur?: () => void;
  errorMessage?: string | null;
}

const defaultProps: DefaultProps = {};

type Props = InjectedProps & UpdateUsernameProps;

const UpdateUsername = (props: Props) => {
  const {
    classes,
    style,
    className,
    formatMessage,
    innerRef,
    username,
    flow,
    onUsernameChange,
    onUsernameBlur,
    errorMessage,
  } = props;

  return (
    <div ref={innerRef} className={classnames(className)} style={style}>
      <TextField
        text={username}
        onChangeText={onUsernameChange}
        onBlur={onUsernameBlur}
        label={formatMessage(messages.username)}
        hint={formatMessage(messages.usernamePlaceholder)}
        errorMessage={errorMessage}
        textStyle={{ fontFamily: "Red Hat Text" }}
        className={classnames("no-border-radius")}
      />

      <div
        className={classnames(
          flow === "DASHBOARD"
            ? classes.dashboardRequirementSection
            : classes.activationRequirementSection
        )}
      >
        <span
          className={classnames(
            flow === "DASHBOARD" ? classes.header : classes.label
          )}
        >
          {formatMessage(messages.usernameRequirements)}:
        </span>
        <div>
          <ul
            className={classnames(
              classes.requirements,
              flow === "DASHBOARD"
                ? classes.dashboardRequirements
                : classes.activationRequirements
            )}
          >
            <li>{formatMessage(messages.unique)}</li>
            <li>{formatMessage(messages.length)}</li>
            <li>{formatMessage(messages.begin)}</li>
            <li>{formatMessage(messages.allowedCharacters)}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

UpdateUsername.defaultProps = defaultProps;

export default withIntl(stylize<Props, DefaultProps>(styles)(UpdateUsername));
